import { Loader as MapsLoader } from '@googlemaps/js-api-loader';
import AnalyticsHelper from '../../utils/analytics-helper.js';
import DealerFilters from './dealer-filters.js';

export default class DealerSearch {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.fad-search-location-wrapper');
        this.form = this.el.querySelector('form');
        this.input = this.el.querySelector('.fad-search-input');
        this.submit = this.el.querySelector('.fad-search-submit');
        this.location = this.el.querySelector('.fad-search-location');

        this.regexType = parent.el.querySelector('.fad-search-input').dataset.regex;
        this.regexErrorMsg = parent.el.querySelector('.fad-search-input').dataset.regexerror;
        this.regexErrorWraper = parent.el.querySelector('.regex-error');
        this.regex = new RegExp(this.regexType);

        this.lastViewed = parent.lastViewed;
        this.loader = parent.loader;
        this.results = parent.results;
        this.filter = this.el.querySelector('.fad-search-filters');
        this.filters = new DealerFilters(this, router);

        this.previous = {};
        this.autocomplete();
        this.currentLocation();
        this.bind();
        this.toggleSubmit();
    }

    autocomplete() {
        if (this.input.dataset.autocomplete) {
            const mapsLoader = new MapsLoader({ apiKey: this.input.dataset.mapapikey, version: 'weekly', libraries: ['places'] });
            mapsLoader.load().then(() => {
                new google.maps.places.Autocomplete(this.input, { types: ['geocode', 'establishment'], componentRestrictions: { country: this.input.dataset.mapregion } });
            });
        }
    }

    currentLocation() {
        if (navigator.geolocation && window.location.protocol === 'https:') {
            this.location.addEventListener('click', (e) => {
                e.preventDefault();
                navigator.geolocation.getCurrentPosition((pos) => {
                    const lat = pos.coords.latitude;
                    const lng = pos.coords.longitude;
                    const value = `${lat} ${lng}`;

                    if (value !== this.router.params.get('query')) {
                        this.router.params.set('query', value);
                        this.router.update();
                    }
                });
            });
        } else {
            this.location.classList.add('hide');
        }
    }
    pageURL() {
        return window.location.href;
    }
    bind() {
        
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.update();
            this.filters.update();
            this.router.update();
            const filtersParameterValue = this.router.params.get('filters');
            const filterValues = filtersParameterValue ? filtersParameterValue : 'Not selected';
            AnalyticsHelper.template(this.form, { filters: filterValues, pageURL: this.pageURL(), query: this.input.value });
            //AnalyticsHelper.push(this.form);
            this.filters.filterActions.classList.add('hide');
        });

        this.input.addEventListener('focus', (e) => {
            this.filters.toggleError();
        });

        this.input.addEventListener('keyup', (e) => {
            this.toggleSubmit();
        });
    }

    toggleSubmit() {
        if (this.filters.isFilterRequired && this.input.value.trim().length == 0) {
            this.submit.disabled = true;
        } else {
            if (this.submit.disabled !== false) {
                this.submit.disabled = false;
            }
        }
    }

    update(){
        const value = this.input.value;
        value ? this.router.params.set('query', value) : this.router.params.delete('query');
    }

    show() {
        this.populate();
        this.filters.show();
        this.search();
    }

    populate() {
        const query = this.router.params.get('query');
        this.input.value = query;
    }

    search() {
        
        const current = {
            query: this.router.params.get('query'),
            filters: this.router.params.get('filters'),
            regexValid : this.regex.test(this.input.value)
        };

        if (!current.query || (this.filters.isFilterRequired && !current.filters)) {
            this.results.hide();
            this.lastViewed.show();
        }
        
        else if (current.regexValid == false ){
            this.lastViewed.hide();
            this.results.hide();
            this.regexValidationShow();
            
        }
         else if (_.isEqual(current, this.previous)) {
            this.results.show();
            this.lastViewed.hide();
            
            
        } else {
            this.results.hide();
            this.lastViewed.hide();
            this.loader.show();
            this.regexValidationHide();

            this.previous = current;
            this.filter.value = current.filters;

            fetch(this.form.action, { method: 'POST', body: new FormData(this.form) })
                .then((response) => response.json())
                .then((results) => this.results.render(current.query, results))
                .catch((error) => this.results.render(current.query));

            AnalyticsHelper.push(this.form);
        }
    }

    toggle() {
        if (this.valid()) {
            this.submit.disabled = false;
        } else {
            this.submit.disabled = true;
        }
    }

    regexValidationShow() {
        this.regexErrorWraper.classList.remove('hide')
        this.regexErrorWraper.querySelector('.fad-filter-error-message').innerText = this.regexErrorMsg;
        
    }

    regexValidationHide() {
        this.regexErrorWraper.classList.add('hide');
    }
}
